import React, { useState, useEffect } from 'react';
import { songService } from '../services/api';

const HealthCheck = () => {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        await songService.checkHealth();
        setIsOnline(true);
      } catch (err) {
        setIsOnline(false);
      }
    };

    check();
    const interval = setInterval(check, 60000); // Check every minute
    return () => clearInterval(interval);
  }, []);

  if (isOnline) return null; // Don't show anything if healthy (less clutter for members)

  return (
    <div className="fixed bottom-12 left-0 right-0 bg-red-500 text-white text-xs py-1 text-center z-50">
      Connection Lost - Reconnecting...
    </div>
  );
};

export default HealthCheck;
